import { render, staticRenderFns } from "./setting-defaultAnnotationTools.vue?vue&type=template&id=435c20a3&scoped=true&"
import script from "./setting-defaultAnnotationTools.vue?vue&type=script&lang=js&"
export * from "./setting-defaultAnnotationTools.vue?vue&type=script&lang=js&"
import style0 from "./setting-defaultAnnotationTools.vue?vue&type=style&index=0&id=435c20a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435c20a3",
  null
  
)

export default component.exports